import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth.service";

/**
 * This interceptor adds no cache fields to an http request. This is done as IE11 will cache results
 * if not explicitly told not to. This will only add no-cache to requests that do not have specified caching;
 * otherwise returns the original request.
 * */
@Injectable()
export class HttpNoCacheInterceptor implements HttpInterceptor {

    // CTOR
    constructor(
        public readonly authService: AuthService
    ) { }


    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isApiCall(req.url) && this.authService.isLoggedIn) {
            const headers = req.headers;
            const keys = Object.keys(CacheHeaders);
            for (let key of headers.keys())
                if (keys.findIndex(x => x === key) !== -1)
                    return next.handle(req);

            return next.handle(req.clone({
                headers: req.headers
                    .set(CacheHeaders.CacheControl, "no-cache")
                    .set(CacheHeaders.Pragma, "no-cache")
            }));
        } else {
        return next.handle(req);
        }
    }

    isApiCall(url: string): boolean {
        const lowered = url.toLowerCase();
        return lowered.startsWith("api") || lowered.startsWith("/api");
    }
}

enum CacheHeaders {
    CacheControl = "Cache-Control",
    Pragma = "Pragma",
}